// Translation: Login > Landing > Form (Arabic)
export default Object.freeze({
	form: {
		actions: {
			login: {
				label: 'تسجيل الدخول'
			}
		},
		fields: {
			code: {
				placeholder: ''
			},
			email: {
				placeholder: 'أدخل عنوان البريد الإلكتروني'
			},
			password: {
				placeholder: 'أدخل كلمة المرور'
			}
		},
		options: {
			register: {
				action: 'إنشاء حساب',
				label: 'هل تحتاج الى حساب؟'
			},
			reset: {
				action: 'نسيت كلمة المرور؟'
			}
		},
		title: {
			credentials: '',
			twoFactorAuthentication: ''
		}
	}
})
